(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    shouldShowTransparentHeader() {
      const isHomePage = window?.location?.pathname === '/';

      // Get current page handle
      const currentPath = window?.location?.pathname;
      const pageHandle = currentPath.replace('/pages/', '').replace('/', '');

      // Get allowed pages from data attribute
      const allowedPages = this.getAttribute('data-transparent-pages') || '';
      const allowedPagesArray = allowedPages ? allowedPages.split(',').map(page => page.trim()) : [];

      // Check if current page should have transparent header
      return isHomePage || allowedPagesArray.includes(pageHandle);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.isAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.transparentHeader = this.hasAttribute('data-transparent');
      const isHomePage = window?.location?.pathname === '/';

      const shouldShowTransparentHeader = this.shouldShowTransparentHeader();

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.transparentHeader && this.isAlwaysSticky && shouldShowTransparentHeader) {
        const announcementBar = document.querySelector('.announcement-bar-section');
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 38;
        this.header.style.top = `${announcementBarHeight}px`;
        this.header.classList.add('transparent-header');
      } else if (this.transparentHeader && this.isAlwaysSticky && !shouldShowTransparentHeader) {
        this.header.classList.add('transparent-header-no-home');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.transparentHeader) {
        const announcementBar = document.querySelector('.announcement-bar-section');
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 38;
        
        if (scrollTop > announcementBarHeight) {
          this.header.classList.add('scrolled-past-header');
        } else {
          this.header.classList.remove('scrolled-past-header');
          this.header.style.top = `${announcementBarHeight}px`;
        }
      } else {
        // Lógica original para headers no transparentes
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.transparentHeader) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.transparentHeader) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.transparentHeader) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-history"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.timeline-carousel');

    carousels.forEach(function (carousel) {
      const track = carousel.querySelector('.timeline-content-track');
      const items = carousel.querySelectorAll('.timeline-content-item');
      const yearItems = carousel.querySelectorAll('.timeline-year-item');
      const prevBtn = carousel.querySelector('.timeline-nav--prev');
      const nextBtn = carousel.querySelector('.timeline-nav--next');

      let currentIndex = 1; // Start with middle item
      const totalItems = items.length;

      function updateTimelinePositions() {
        const isMobile = window.innerWidth <= 1023;
        if (isMobile) return;

        const timelineTrack = carousel.querySelector('.timeline-years-track');
        if (!timelineTrack) return;

        const availableHeight = 530; // 650px - 60px padding top - 60px padding bottom
        const itemHeight = 40;
        const minGap = 45;

        // Calculate spacing based on number of items
        const totalItemsHeight = yearItems.length * itemHeight;
        const availableGapSpace = availableHeight - totalItemsHeight;
        const gap = Math.max(minGap, availableGapSpace / (yearItems.length - 1));

        // Position each item vertically
        yearItems.forEach((item, index) => {
          const topPosition = index * (itemHeight + gap);
          item.style.top = `${topPosition}px`;

          // Update segment height connecting to next item
          const segment = item.querySelector('.timeline-segment');
          if (segment && index < yearItems.length - 1) {
            const segmentHeight = Math.max(gap, 50); // Minimum 50px for the line
            segment.style.height = `${segmentHeight}px`;
          }
        });
      }

      function updateTimelineLine() {
        const isMobile = window.innerWidth <= 1023;
        if (!isMobile) return;

        const timelineTrack = carousel.querySelector('.timeline-years-track');
        if (!timelineTrack) return;

        // Calculate line width based on actual element positions
        const firstDot = yearItems[0]?.querySelector('.timeline-dot');
        const lastDot = yearItems[yearItems.length - 1]?.querySelector('.timeline-dot');

        if (firstDot && lastDot && timelineTrack.querySelector('::before')) {
          const firstDotRect = firstDot.getBoundingClientRect();
          const lastDotRect = lastDot.getBoundingClientRect();
          const trackRect = timelineTrack.getBoundingClientRect();

          const lineStart = firstDotRect.left - trackRect.left + firstDotRect.width / 2;
          const lineEnd = lastDotRect.left - trackRect.left + lastDotRect.width / 2;
          const lineWidth = lineEnd - lineStart;

          // Update line via CSS custom properties
          timelineTrack.style.setProperty('--timeline-line-start', lineStart + 'px');
          timelineTrack.style.setProperty('--timeline-line-width', lineWidth + 'px');
        }
      }

      function scrollTimelineToShowYear(yearIndex) {
        const isMobile = window.innerWidth <= 1023;
        if (!isMobile) return;

        const timelineYears = carousel.querySelector('.timeline-years');
        const timelineTrack = carousel.querySelector('.timeline-years-track');
        const targetYearItem = yearItems[yearIndex];

        if (!targetYearItem || !timelineYears || !timelineTrack) return;

        const containerWidth = timelineYears.offsetWidth;
        const containerScrollLeft = timelineYears.scrollLeft;
        const targetLeft = targetYearItem.offsetLeft;
        const targetWidth = targetYearItem.offsetWidth;

        // Calculate if the year is visible in the current viewport
        const isFullyVisible =
          targetLeft >= containerScrollLeft && targetLeft + targetWidth <= containerScrollLeft + containerWidth;

        if (!isFullyVisible) {
          // Calculate the ideal scroll position to center the year
          const idealScrollLeft = targetLeft - containerWidth / 2 + targetWidth / 2;

          // Constrain scroll position to valid range
          const maxScroll = timelineTrack.scrollWidth - containerWidth;
          const newScrollLeft = Math.max(0, Math.min(idealScrollLeft, maxScroll));

          // Smooth scroll animation
          timelineYears.scrollTo({
            left: newScrollLeft,
            behavior: 'smooth',
          });
        }
      }

      function updateTimelineYearPositions() {
        const isMobile = window.innerWidth <= 1023;
        if (isMobile) return;

        const timelineTrack = carousel.querySelector('.timeline-years-track');
        if (!timelineTrack) return;

        const trackHeight = 530;
        const centerPoint = trackHeight / 2;
        const itemHeight = 40;
        const minGap = 45;

        // Calculate spacing based on number of items
        const totalItemsHeight = yearItems.length * itemHeight;
        const availableGapSpace = trackHeight - totalItemsHeight;
        const gap = Math.max(minGap, availableGapSpace / Math.max(1, yearItems.length - 1));

        // If all items fit comfortably, no need to move
        if (totalItemsHeight + (yearItems.length - 1) * gap <= trackHeight) {
          yearItems.forEach((item, index) => {
            const topPosition = index * (itemHeight + gap);
            item.style.top = `${topPosition}px`;

            // Update segment height connecting to next item
            const segment = item.querySelector('.timeline-segment');
            if (segment && index < yearItems.length - 1) {
              const segmentHeight = Math.max(gap, 50); // Minimum 50px for the line
              segment.style.height = `${segmentHeight}px`;
            }
          });
        } else {
          // When there are many items, center the active item
          const activeItemPosition = currentIndex * (itemHeight + gap) + itemHeight / 2;
          const offsetY = centerPoint - activeItemPosition;

          // Calculate limits to avoid empty spaces at top/bottom
          const firstItemWithOffset = offsetY;
          const lastItemWithOffset = (yearItems.length - 1) * (itemHeight + gap) + offsetY;

          let finalOffsetY = offsetY;

          // Adjust offset if needed to keep items visible
          if (firstItemWithOffset > 0) {
            finalOffsetY = 0;
          } else if (lastItemWithOffset < trackHeight - itemHeight) {
            finalOffsetY = trackHeight - itemHeight - (yearItems.length - 1) * (itemHeight + gap);
          }

          // Position each item vertically with the applied offset
          yearItems.forEach((item, index) => {
            const basePosition = index * (itemHeight + gap);
            const finalPosition = basePosition + finalOffsetY;

            item.style.top = `${finalPosition}px`;

            // Update segment height connecting to next item
            const segment = item.querySelector('.timeline-segment');
            if (segment && index < yearItems.length - 1) {
              const segmentHeight = Math.max(gap, 50); // Minimum 50px for the line
              segment.style.height = `${segmentHeight}px`;
            }
          });
        }
      }

      function updateCarousel() {
        const isMobile = window.innerWidth <= 1023;

        if (isMobile) {
          // Mobile: simple horizontal scroll
          track.style.transform = `translateX(-${currentIndex * 100}%)`;

          // Reset all item styles for mobile
          items.forEach((item, index) => {
            item.classList.remove('is-active', 'is-prev', 'is-next');
            item.style.opacity = '';
            item.style.transform = '';
            item.style.top = '';
            item.style.height = '';

            if (index === currentIndex) {
              item.classList.add('is-active');
            }
          });

          // Scroll timeline to show the active year
          scrollTimelineToShowYear(currentIndex);

          // Update timeline line
          updateTimelineLine();
        } else {
          // Desktop: vertical stack with 3 visible
          items.forEach((item, index) => {
            item.classList.remove('is-active', 'is-prev', 'is-next');
            // Reset inline styles
            item.style.opacity = '';
            item.style.transform = '';

            const offset = index - currentIndex;

            if (offset === -1) {
              item.classList.add('is-prev');
              item.style.transform = `translateY(0) scale(0.9)`;
              item.style.opacity = '0.3';
            } else if (offset === 0) {
              item.classList.add('is-active');
              item.style.transform = `translateY(200px) scale(1)`;
              item.style.opacity = '1';
            } else if (offset === 1) {
              item.classList.add('is-next');
              item.style.transform = `translateY(400px) scale(0.9)`;
              item.style.opacity = '0.3';
            } else if (offset < -1) {
              // Items before the visible window
              item.style.transform = `translateY(${0 + (offset + 1) * 50}px) scale(0.8)`;
              item.style.opacity = '0';
            } else {
              // Items after the visible window
              item.style.transform = `translateY(${400 + (offset - 1) * 50}px) scale(0.8)`;
              item.style.opacity = '0';
            }
          });

          // Update timeline year positions
          updateTimelineYearPositions();
        }

        // Update year indicators
        yearItems.forEach((year, index) => {
          year.classList.remove('is-active', 'is-passed');
          if (index === currentIndex) {
            year.classList.add('is-active');
          } else if (index < currentIndex) {
            year.classList.add('is-passed');
          }
        });

        // Update navigation buttons
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === totalItems - 1;
      }

      function goToSlide(index) {
        const newIndex = Math.max(0, Math.min(index, totalItems - 1));

        // If clicking on a year in mobile, first scroll to show it, then activate
        const isMobile = window.innerWidth <= 1023;
        if (isMobile && newIndex !== currentIndex) {
          scrollTimelineToShowYear(newIndex);

          // Small delay to let scroll animation start before changing active state
          setTimeout(() => {
            currentIndex = newIndex;
            updateCarousel();
          }, 100);
        } else {
          currentIndex = newIndex;
          updateCarousel();
        }
      }

      function nextSlide() {
        if (currentIndex < totalItems - 1) {
          currentIndex++;
          updateCarousel();
        }
      }

      function prevSlide() {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      }

      // Event listeners
      prevBtn.addEventListener('click', prevSlide);
      nextBtn.addEventListener('click', nextSlide);

      yearItems.forEach((year, index) => {
        year.addEventListener('click', () => goToSlide(index));
      });

      // Touch support for mobile
      let touchStartX = 0;
      let touchEndX = 0;

      track.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
        },
        { passive: true }
      );

      function handleSwipe() {
        if (touchEndX < touchStartX - 50) nextSlide();
        if (touchEndX > touchStartX + 50) prevSlide();
      }

      // Handle window resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updateTimelinePositions();
          updateCarousel();
          updateTimelineLine();
        }, 250);
      });

      // Initialize
      updateTimelinePositions();
      updateCarousel();

      // Ensure the initial active year is visible on load for mobile
      if (window.innerWidth <= 1023) {
        setTimeout(() => {
          scrollTimelineToShowYear(currentIndex);
          updateTimelineLine();
        }, 100);
      }
    });
  });

  // Reinitialize on theme editor changes
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.timeline-carousel')) {
      // Re-run initialization
      const evt = new Event('DOMContentLoaded');
      document.dispatchEvent(evt);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
